export default __webpack_public_path__ + "static/media/wokuni.11b03d35.jpeg";